import React, { useContext, useEffect } from "react";
import { ChatbotContext } from "@/store/context/ChatbotContext.tsx";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";

import { Button } from "@/components/shadcn/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/shadcn/form";
import { Switch } from "@/components/shadcn/switch";
import { Input } from "@/components/shadcn/input";

import { useTranslation } from "react-i18next";
import { saveSettings } from "@/store/chatbot.ts";
import { useParams } from "react-router-dom";
import {Icon} from "@/components/Icon.tsx";

const FormSchema = z.object({
  enableEmails: z.boolean(),
  emails: z.string().or(z.literal("")),
});

export default function LeadsNotifications() {
  const { chatbotID } = useParams();
  const { t } = useTranslation();
  const { chatSettings, viewChatbot, invalidateChatbot, setSettings } =
    useContext(ChatbotContext);

  const form = useForm<z.infer<typeof FormSchema>>({
    resolver: zodResolver(FormSchema),
    defaultValues: {
      enableEmails: chatSettings?.leads.enableEmails,
      emails: chatSettings?.leads.emails,
    },
  });
  
  function onSubmit(data: z.infer<typeof FormSchema>) {
    let set = Object.assign({}, chatSettings);
    set.leads = { ...set.leads, ...data };
    saveSettings(chatbotID, set, invalidateChatbot);
  }

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(onSubmit)}
        className="w-full xl:w-2/3 space-y-6 pt-6"
      >
        <h3 className="inline-block text-lg font-medium">
          <Icon
            className="inline-block mr-1"
            icon="ic:outline-notifications-active"
            width={20}
          />
          {t("leads.email_notifications")}
        </h3>

        <FormField
          control={form.control}
          name="enableEmails"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-3 shadow-sm">
              <div className="space-y-0.5">
                <FormLabel className="cursor-pointer">
                  {t("leads.enable_email_notifications")}
                </FormLabel>
                <FormDescription>
                  {t("leads.enable_email_notifications.description")}
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="emails"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("leads.emails")}</FormLabel>
              <FormControl>
                <Input {...field} />
              </FormControl>
              <FormDescription>
                {t("leads.emails.description")}
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit">Save</Button>
      </form>
    </Form>
  );
}
